import React from 'react';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import type { StaticContext } from '@swf/core/types/StaticContext';
import { SignupWizard } from '@swf/first';

import FirstRoute from './FirstRoute';
import ModalRoute from './ModalRoute';

const SignupRoute: React.FC<{ staticContext: StaticContext }> = ({ staticContext = {} }) => {
  const SWCSignup = useFeature(FeatureFlag.SwcSignup);
  const bankID = useFeature(FeatureFlag.BankID);
  const path = `/auth/registration${bankID ? '/bankid' : ''}`;

  return SWCSignup ? (
    <FirstRoute component={SignupWizard} staticContext={staticContext} />
  ) : (
    <ModalRoute modal={{ path }} staticContext={staticContext} />
  );
};

export default SignupRoute;
